import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@tinct/web-components';
import { Organization, UpdateOrganization } from '@tinct/core-api-models';
import { useUpdateOrganizationForm } from '../hooks/use-update-organization-form';
import { createConnectedInputHelpers } from '@tinct/web-form';
import { FormProvider } from 'react-hook-form';

type UpdateOrganizationModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  organization: Organization;
};

export const UpdateOrganizationModal = ({
  open,
  onOpenChange,
  organization,
}: UpdateOrganizationModalProps) => {
  const { form, handleSubmit, isLoading } = useUpdateOrganizationForm({
    organization,
    onSuccess: () => onOpenChange(false),
  });

  const { ControlledTextInput } = createConnectedInputHelpers<UpdateOrganization>();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Rename workspace</DialogTitle>
        </DialogHeader>

        <FormProvider {...form}>
          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <ControlledTextInput
              direction="vertical"
              name="name"
              label="Workspace's name"
            />

            <DialogFooter>
              <Button
                type="button"
                variant="outline"
                onClick={() => onOpenChange(false)}
              >
                Cancel
              </Button>
              <Button type="submit" isLoading={isLoading}>
                Change name
              </Button>
            </DialogFooter>
          </form>
        </FormProvider>
      </DialogContent>
    </Dialog>
  );
};
